module.exports = __webpack_public_path__ + "img/q-8-3@2x.90ec3bfa.png";